module.exports = __webpack_public_path__ + "static/media/Group 16.e155b52c.png";